import { selectTagsForOrderMap, selectTagsForPersonMap } from 'entities/tags';
import { FC, Fragment } from 'react';
import { useAppSelector } from 'shared/lib/store';
import { TagCard } from 'shared/ui/cards/tagCard';
import { MarginBottom } from './styles';
import { Flex } from 'shared/ui/flex';

// const Title = withTypographyContainer(Typography);

interface OrderTagsProps {
	tags?: string[];
	forOrder?: boolean;
	title?: string;
	textTagPointer?: boolean;
	outputDashInsteadTags?: boolean;
}

export const OrderTags: FC<OrderTagsProps> = ({
	tags,
	forOrder = false,
	// title = 'Теги',
	outputDashInsteadTags = false,
}) => {
  // const Title = withTypographyContainer(Typography);

	const tagsForOrder = useAppSelector(selectTagsForOrderMap);
	const tagsForPerson = useAppSelector(selectTagsForPersonMap);

  if (!tags?.length) {
    return <></>
  }

	return (
		<Fragment>
			{((tags && tags.length > 0) || outputDashInsteadTags) && (
				<MarginBottom $value='0px'>

					<Flex $wrap="wrap" $gap="5px" $margin="0">
						{tags?.map(tag => {
							let tagValue;
							if (forOrder) {
								tagValue = tagsForOrder.get(tag);
							} else {
								tagValue = tagsForPerson.get(tag);
							}

							const tagColor = tagValue?.color;

							return (
								<TagCard
									key={tag}
									name={tag}
									border={tagColor}
                  bg={tagColor}
									outputCloseButton={false}
								/>
							);
						})}
					</Flex>
				</MarginBottom>
			)}
		</Fragment>
	);
};
